var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","data-theme":_vm.theme}},[_c('AppBar',{attrs:{"theme":_vm.theme},on:{"toggle-theme":_vm.toggleTheme}}),_c('HeroSection'),_c('ExplorerSection'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }